import type { SuccessNotificationRepository } from '@/domains/ui/successNotification.repository';
import { BaseNotificationService } from './baseNotification.service';

/**
 * Servicio específico para notificaciones de éxito usando SweetAlert2
 * Cumple con SRP: única responsabilidad es mostrar confirmaciones exitosas
 * Usa servicio base para eliminar duplicación de configuración
 */
class SuccessNotificationService
  extends BaseNotificationService
  implements SuccessNotificationRepository
{
  /**
   * Muestra notificación de éxito con timer automático
   * @param message - Mensaje de confirmación a mostrar
   */
  async showSuccess(message: string): Promise<void> {
    await this.showNotification(
      message,
      BaseNotificationService.CONFIGS.SUCCESS,
    );
  }

  async showSuccessWithConfirm(message: string): Promise<void> {
    await this.showNotification(
      message,
      BaseNotificationService.CONFIGS.SUCCESS_CONFIRM,
    );
  }
}

export const successNotificationService = new SuccessNotificationService();
